<template>
  <form name="passport-form">
    <PassportMain
      :form="form"
      :data="data"
      :disabled="isView"
      :skeleton="skeleton"
      :is-create="isCreate"
      :is-view="isView"
      class="my-4"
    />
  </form>
</template>

<script>
import BLayoutForm from '@/components/layouts/BLayoutForm.vue'
import PassportMain from '@/views/PassportsList/components/PassportMain.vue'

const createDefaultData = () => ({
  long_name: '',
  short_name: '',
  region: '',
  municipality: '',
})

export default {
  name: 'PassportForm',
  components: {
    PassportMain,
  },
  extends: BLayoutForm,
  props: {
    editable: Boolean,
    skeleton: Boolean,
    loading: Boolean,
    data: {
      type: Object,
      required: true,
      default: createDefaultData,
    },
  },
}
</script>
